import * as S from './styles'
import { useTranslation } from 'react-i18next'

const CustomPathology = () => {
  const { t } = useTranslation()

  return (
    <S.CustomPathologyContainer>
      <div>
        <h4>{t('titles.pathologicalConditions')}</h4>
        <ul>
          {Array.from({ length: 21 }).map((_, idx) => (
            <li>{t(`titles.pathologicalConditions.${idx + 1}`)}</li>
          ))}
        </ul>
      </div>
    </S.CustomPathologyContainer>
  )
}

export default CustomPathology
